module.exports = __webpack_public_path__ + "media/images/favicon-32x32-fa11a8d6.png";